// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__3QwOq","header":"ReportDetails_header__29t2m","title":"ReportDetails_title__3LSHk","left":"ReportDetails_left__32_VL"};